import { Suspense, lazy } from "react";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./styles.scss";
import "./global.css";
import { Provider } from "react-redux";
import store from "./store/index.ts";

import "./common/styles/common.scss";
import Loader from "./common/components/Loader/index.tsx";
import ProtectedRoute from "./layouts/protectedRoute.tsx";
import RoleBasedRoute from "./layouts/RoleBasedRoute.tsx";

const Header = lazy(() => import("./common/Header/index"));
const Subheader = lazy(() => import("./common/Subheader/index"));
const LoginScreen = lazy(() => import("./pages/LoginScreen/index.tsx"));
const CreateMeeting = lazy(() => import("./pages/CreateMeeting/index.tsx"));
const TrackRegistrations = lazy(
  () => import("./pages/TrackNmanageRegistrations"),
);
const ViewAnalytics = lazy(() => import("./pages/Analytics"));
const Zoom = lazy(() => import("./pages/Zoom/index.tsx"));
const VerifyUserFace = lazy(() => import("./pages/VerifyUserFace/index.tsx"));
const Profile = lazy(() => import("./pages/Profile/index.tsx"));
const Redirect = lazy(() => import("./pages/Redirect/index.tsx"));
const Admin = lazy(() => import("./pages/Admin/index.tsx"));
const MuiDataGrid = lazy(() => import("./pages/SeerkersList/index.tsx"));
const UploadGrid = lazy(() => import("./pages/UploadTable/index.tsx"));
const Unathorized = lazy(() => import("./pages/Unathorized/index.tsx"));

interface AppLayoutProps {
  type: string;
}

//App layout to render the nested routes with a subheader component
const AppLayout: React.FC<AppLayoutProps> = ({ type }) => {
  return (
    <>
      <Subheader appType={type} />
      <Outlet /> {/* This will render the nested routes */}
    </>
  );
};

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Suspense fallback={<Loader type="large" />}>
            <Header />
            <div>
              <Routes>
                <Route path="/" element={<LoginScreen />} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/verifyuserface" element={<VerifyUserFace />} />
                <Route element={<ProtectedRoute />}>
                  {/* Routes for Admin starts here */}
                  <Route
                    path="/admin"
                    element={
                      <RoleBasedRoute
                        element={<AppLayout type="admin" />}
                        allowedRoles={["mahatria", "admin"]}
                      />
                    }
                  >
                    <Route path="uploadTable" element={<UploadGrid/>} />
                    <Route path="home" element={<Admin />} />
                    <Route
                      path="createinfinipath"
                      element={<CreateMeeting />}
                    />
                    <Route path="viewanalytics" element={<ViewAnalytics />} />
                    <Route path="sessions" element={<TrackRegistrations />} />
                    <Route path="zoom" element={<Zoom />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="redirect" element={<Redirect />} />
                    <Route path="seekerslist" element={<MuiDataGrid />} />
                  </Route>
                  {/* Routes for Admin ends here */}
                </Route>
                <Route path="*" element={<LoginScreen />} />
                <Route path="/unauthorized" element={<Unathorized />} />
              </Routes>
            </div>
          </Suspense>
        </div>
      </Router>
    </Provider>
  );
}
